import React from 'react';
import { compose } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

const styles = {
  buttonFont: {
    fontSize: '1.2rem'
  }
};

const enhance = compose();

const button = enhance(({ classes, onClickAction }) => {
  return (
    <Button
      color="primary"
      onClick={onClickAction}
      className={classes.buttonFont}
    >
      新規登録画面に戻る
    </Button>
  );
});

export default withRouter(withStyles(styles)(button));
